// extracted by mini-css-extract-plugin
module.exports = {"custom-input":"inputSkydropx_custom-input__PWOaO"};